import { RevenueApi } from '@/apis';
import { flow, makeObservable, observable } from 'mobx';
import RootStore from '.';
import BaseStore from './BaseStore';
import { TableState } from '@tanstack/react-table';
import { ResponseData } from '@/types/http';
import { Revenue, RevenueDetail } from '@/types/revenue';

export default class RevenueStore extends BaseStore {
    api: RevenueApi;
    allRevenue: Revenue[] = [];
    revenueDetail: RevenueDetail = {} as RevenueDetail;
    totalRevenue: number | string | undefined = undefined;

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            allRevenue: observable,
            revenueDetail: observable,
            totalRevenue: observable,
            getAllRevenue: flow.bound,
            getRevenueByOrder: flow.bound,
            closeSales: flow.bound,
            exportExcelRevenues: flow.bound,
            exportPdfRevenues: flow.bound
        });
        this.api = new RevenueApi();
    }

    *getAllRevenue(searchParams?: any, paging?: TableState) {
        try {
            const payload = {
                ...this.convertPagingFromTableToRequest(paging ?? this.paging),
                ...searchParams
            };
            const res: ResponseData<any> = yield this.rootStore.apiStore.call(
                this.api,
                this.api.getAllRevenue,
                {
                    ...payload,
                    sortDir: payload?.sortDir || 'DESC',
                    sortKey: payload?.sortKey || 'rentalFrom'
                }
            );
            if (res.ok) {
                this.allRevenue = res.data.elements;
                this.totalRevenue = res.data.total;
                this.paging = {
                    ...this.paging,
                    sorting: paging?.sorting ?? [],
                    pagination: this.convertPaginationFromRequestToTable(
                        res.data.paginate
                    )
                };
                this.totalRecord = res.data.paginate.totalRecord;
            }
        } catch (error) { }
    }

    *getRevenueByOrder(orderId: number) {
        try {
            const res: ResponseData<any> = yield this.rootStore.apiStore.call(
                this.api,
                this.api.getRevenueByOrder,
                orderId
            );
            if (res?.ok) {
                this.revenueDetail = res?.data || null;
                return res?.data;
            }
            return false;
        } catch (error) { }
    }

    *closeSales(orderIds: number[]) {
        try {
            const res: ResponseData<any> = yield this.rootStore.apiStore.call(
                this.api,
                this.api.closeSales,
                orderIds
            );
            if (res?.ok) {
                return true;
            }
            return false;
        } catch (error) { }
    }

    *exportExcelRevenues(payload) {
        try {
            const res: ResponseData<any> = yield this.rootStore.apiStore.call(
                this.api,
                this.api.exportExcelRevenues,
                {
                    ...payload,
                    sortDir: payload?.sortDir || 'DESC',
                    sortKey: payload?.sortKey || 'rentalFrom'
                }
            );
            if (res) {
                return res;
            }
            return false;
        } catch (error) { }
    }

    *exportPdfRevenues(payload) {
        try {
            const res: ResponseData<any> = yield this.rootStore.apiStore.call(
                this.api,
                this.api.exportPdfRevenues,
                {
                    ...payload,
                    sortDir: payload?.sortDir || 'DESC',
                    sortKey: payload?.sortKey || 'rentalFrom'
                }
            );
            if (res) {
                return res;
            }
            return false;
        } catch (error) { }
    }

    clean(): void {
        super.clean();

        this.allRevenue = [];
        this.revenueDetail = {} as RevenueDetail;
    }
}
